mutation deleteLeadsPipelineStatus($input: DeleteLeadsPipelineStatusInput!) {
  deleteLeadsPipelineStatus(input: $input) {
    id
    companyId
    name
    position
  }
}
